import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { fixedIncomeMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { DynamicCustomFiltersProps } from '../../../../../../../../store/product/types';
import { AssetCaptionType } from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetCaptions';
import {
  dailyLiquidityCaption,
  fgcProtectedCaption,
  qualifiedInvestorCaption,
  taxExemptCaption,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetCaptions/constants';
import {
  applicationAmountFilterNew,
  dailyLiquidityFilter,
  getRiskRatingLevelFilter,
  indexersFilter,
  marketOptionFilter,
  monthsToRedemptionFilter,
  taxExemptFilter,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetFilters/constants';
import {
  transformCustomCategories,
  transformCustomFilters,
} from '../../../../../../../BatchTicket/components/DynamicAsset/constants';

import { FixedIncomeProduct } from '.';

const fixedIncomeCaptions: AssetCaptionType[] = [
  qualifiedInvestorCaption,
  taxExemptCaption,
  dailyLiquidityCaption,
  fgcProtectedCaption,
];

export const fixedIncomeTableHead: TableHeadItemRecurse[] = [
  { title: '', flex: 0.5 },
  { title: 'Produto', orderValue: 'productDisplay', flex: 2 },
  { title: 'Aplic. Min.', orderValue: 'applicationMinimumAmount' },
  { title: 'Vencimento', orderValue: 'maturityDate' },
  { title: 'Carência', orderValue: 'dueDate' },
  { title: 'Liquidez', orderValue: 'liquidityIndicatorNormalized' },
  { title: 'Taxa', orderValue: 'profitabilityTax' },
  { title: 'Rent. até vencimento', orderValue: 'profitabilityToMaturity' },
];

export const availableProductFixedIncomeConstant = {
  id: 'fixedIncome',
  title: 'Renda Fixa',
  color: 'product.rf' as ColorTypes.Option,
  principalComponent: FixedIncomeProduct,
  marketStatusSelector: fixedIncomeMarketStatusQuery,
  tableHead: fixedIncomeTableHead,
  hideTableHead: false,
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [
      getRiskRatingLevelFilter('fixedIncome'),
      ...transformCustomFilters(customFilters),
      dailyLiquidityFilter,
      taxExemptFilter,
      monthsToRedemptionFilter,
      indexersFilter,
      applicationAmountFilterNew,
      marketOptionFilter,
    ];
  },
  hasCategories: true,
  categoriesLabel: 'Categorias',
  categoriesField: 'productSubCategory',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'productSubCategory'),
  captions: fixedIncomeCaptions,
  hasRefresher: false,
} as const;
